'use client';

import { c as _c } from "react/compiler-runtime";
import { TopNavV5MobileBar } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileBar';
import { TopNavV5MobileSlidingPanel } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileSlidingPanel';
export const TopNavV5Mobile = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <nav className="relative overflow-x-clip lg:hidden"><div className="z-50 h-12 w-full bg-bodi-black-text font-medium text-bodi-white"><TopNavV5MobileBar /></div><TopNavV5MobileSlidingPanel /></nav>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};